// Role-based permission helpers shared across the frontend.
export const ROLES = {
  GENERAL: "general_user",
  CONTRIBUTOR: "contributor",
  ADMIN: "admin",
  SUPER_ADMIN: "super_admin",
};

export const ROLE_LABELS = {
  [ROLES.GENERAL]: "General User",
  [ROLES.CONTRIBUTOR]: "Contributor",
  [ROLES.ADMIN]: "Administrator",
  [ROLES.SUPER_ADMIN]: "Super Admin",
};

const RANK = {
  [ROLES.GENERAL]: 0,
  [ROLES.CONTRIBUTOR]: 1,
  [ROLES.ADMIN]: 2,
  [ROLES.SUPER_ADMIN]: 3,
};

export function rank(role) {
  return RANK[role || ROLES.GENERAL] ?? 0;
}

export function isAtLeast(user, minRole) {
  if (!user) return false;
  return rank(user.role) >= rank(minRole);
}

export const canCreateTrade = (u) => isAtLeast(u, ROLES.CONTRIBUTOR);
export const canAddPhase = (u) => isAtLeast(u, ROLES.CONTRIBUTOR);
export const canManageUsers = (u) => isAtLeast(u, ROLES.ADMIN);
export const canOverrideDates = (u) => isAtLeast(u, ROLES.ADMIN);
export const canEditExistingDates = (u) => isAtLeast(u, ROLES.SUPER_ADMIN);
export const canSeeDollarStats = (u) => isAtLeast(u, ROLES.ADMIN);
export const canManageNotificationTemplates = (u) => isAtLeast(u, ROLES.SUPER_ADMIN);

export function canEditTrade(user, trade) {
  if (!user || !trade) return false;
  if (isAtLeast(user, ROLES.ADMIN)) return true;
  return isAtLeast(user, ROLES.CONTRIBUTOR) && trade.user_id === user.id;
}

export const canDeleteTrade = canEditTrade;
